import type {
  TCreateMaintenanceParams,
  TDeleteMaintenanceParams,
  TMaintenanceListItem,
  TUpdateMaintenanceParams,
} from 'core/model/interfaces/maintenance';
import { maintenanceData } from './maintenance.data';
import {
  toCreateMaintenance,
  toGetMaintenanceList,
  toMaintenanceById,
  toUpdateMaintenance,
} from './maintenance.mapper';

export const maintenanceService = {
  getMaintenanceList: async () => {
    const response = await maintenanceData.getMaintenanceList();

    const mappedResponse = toGetMaintenanceList(response);

    return mappedResponse;
  },
  getMaintenanceById: async (id: TMaintenanceListItem['id']) => {
    const response = await maintenanceData.getMaintenanceById({ id });

    const mappedResponse = toMaintenanceById(response, id);

    return mappedResponse;
  },
  createMaintenance: async (params: TCreateMaintenanceParams) => {
    const maintenance = toCreateMaintenance(params);

    const response = await maintenanceData.createMaintenance(maintenance);

    return response;
  },
  updateMaintenance: async (params: TUpdateMaintenanceParams) => {
    const maintenance = toUpdateMaintenance(params);

    const response = await maintenanceData.updateMaintenance(maintenance, params);

    return response;
  },
  deleteMaintenance: async (params: TDeleteMaintenanceParams) => {
    const response = await maintenanceData.deleteMaintenance({ id: params.id });

    return response;
  },
};
